import { Block, component } from '../../../scripts/core/Component'
import Siema from 'siema'

@component('slider')
class Slider extends Block {
  constructor (context) {
    super(context)

    this.container = this.element('container').first()
    this.pagination = []
    this.paginationContainer = this.element('paginationContainer').first()
    this.paginationItem = this.element('paginationItem').first()
    this.nextButtonList = this.element('next')
    this.prevButtonList = this.element('prev')

    this.currentSlide = -1
    this.startIndex = 0

    this.sliderDelegate = new Siema({
      selector: this.container.el,
      perPage: 1,
      startIndex: this.startIndex,
      onInit: this.initHandler.bind(this),
      onChange: this.changeHandler.bind(this)
    })

    this.nextButtonList.list.forEach((item) => {
      item.el.addEventListener('click', () => this.next())
    })

    this.prevButtonList.list.forEach((item) => {
      item.el.addEventListener('click', () => this.prev())
    })


    this.initPagination()
    this.setCurrent(this.startIndex)
  }

  initHandler() {
  }

  changeHandler() {
    this.setCurrent(this.sliderDelegate.currentSlide)
  }

  setCurrent(current) {
    if(this.currentSlide === current) {
      return
    }

    if(this.currentSlide !== -1) {
      this.pagination[this.currentSlide].modifier('current').off()
    }

    this.pagination[current].modifier('current').on()
    this.currentSlide = current
  }

  initPagination() {
    while(this.paginationContainer.el.firstChild) {
      this.paginationContainer.el.removeChild(this.paginationContainer.el.firstChild)
    }

    for (let i = 0; i < this.sliderDelegate.innerElements.length; i++) {
      const paginationItem = this.paginationItem.clone();
      paginationItem.el.addEventListener('click', () => this.sliderDelegate.goTo(i))
      this.paginationContainer.el.appendChild(paginationItem.el)
      this.pagination.push(paginationItem);
    }
  }

  next() {
    this.sliderDelegate.next()
  }

  prev() {
    this.sliderDelegate.prev()
  }
}

export {
  Slider
}


// WEBPACK FOOTER //
// ./components/ui/slider/index.js